import { LitElement, html } from "lit-element";
import { connect } from "pwa-helpers/connect-mixin.js";
import { store } from "../inspx-store.js";
import { fetchNewInspections } from "../actions/new-inspections.js";
import { SharedStyles } from "../styles/shared-styles.js";
import { CardStyles } from "../styles/card-styles.js";
import { InspectionListStyles } from "../styles/inspection-list-styles.js";
import "../elements/inspx-ajax-image.js";
import { image, activate } from "../styles/icons.js";
import { activateInspection } from '../actions/new-inspections.js'
class InspxNewInspections extends connect(store)(LitElement) {
	render() {
		return html`
            ${SharedStyles}
            ${CardStyles}
            ${InspectionListStyles}
            <style>
                .h-image {
                    display: flex;
                    justify-content: center;
                    align-content: center;
                    align-items: center;
                }
                
                .h-image svg {
                    width: 50px;
                    height: 50px;
                    fill: var(--secondary-color-variant1);
                }
            </style>
            
            <div class="list">
                ${this.items.map(c => this._renderCustomer(c))}
            </div>`;
	}

	_renderCustomer(c) {
		return html`
            <div class="topGroup">${c.customerName} </div>
            ${c.projects.map(p => this._renderProject(p))}`;
	}

	_renderProject(p) {
		return html`
            <div class="nestedGroup">${p.projectName}</div>
            ${p.inspections.map(i => this._renderInspection(i))}`;
	}

	_renderInspection(i) {
		return html`
            <div class="card">
                <div class="h-image">
                    ${image}
                </div>
                <div class="h-actions">
					<mwc-button title="activate" @click="${(e) => this.handleActivateInspection(e, i)}">${activate}</mwc-button>
				</div>
                <div class="f">
                 <div>
                    <span>
                        ${i.name}
                    </span>
                          </br>
                      <span>
                           ${(i.Algemeen && i.Algemeen.Algemeen && i.Algemeen.Algemeen.Monsternummer_opdrachtgever) ? "Nr: " + i.Algemeen.Algemeen.Monsternummer_opdrachtgever : ""}
                        </span>
                          <span>
                            ${(i.Algemeen && i.Algemeen.Algemeen && i.Algemeen.Algemeen.Monstername_punt) ? "Punt: " + i.Algemeen.Algemeen.Monstername_punt : ""}
                        </span>                       
                    </div>
                    <div class="info">
                        <span>
                            ${i.type.name}
                        </span>
                        <span>
                            ${i.date}
                        </span>
                    </div>
                </div>
            </div>`;
	}

	static get properties() {
		return { items: Array };
	}

	constructor() {
		super();
		store.dispatch(fetchNewInspections());
		this.items = [];
	}

	stateChanged(state) {
		if (state.newInspections.reload === true)
			store.dispatch(fetchNewInspections());

		this.items = state.newInspections.items;
	}

	handleActivateInspection(e, i) {
		e.preventDefault();
		e.stopPropagation();
		store.dispatch(activateInspection(i._key));
	}
}

window.customElements.define("inspx-new-inspections", InspxNewInspections);
